import React from "react";
import { renderPaymentSteps } from "../Payment/paymentSteps";

export { PAYMENT_STEPS, PAYMENT_STEP_COUNT } from "../Payment/paymentSteps";

export const getEminPayTypeLabel = (paymentType) =>
  Number(paymentType) === 2 ? "Taksitli" : "Tek Çekim";

export const renderEminPaySteps = renderPaymentSteps;

export const EminPayPageLayout = ({
  pageTitle = "Ödeme Talimatı",
  pageSubtitle,
  cardTitle,
  stepBadge,
  paymentTypeLabel,
  activeStep = 0,
  shouldAnimateCard = false,
  children,
}) => (
  <div className="t-createPayment-page t-eminPayOrder-page" style={{ background: "#ffffff" }}>
    <div className="row" style={{ padding: "3%" }}>
      <div className="col-12">
        <div className="t-memberInfo-pageHeader">
          <h1 className="t-memberInfo-pageTitle">{pageTitle}</h1>
          {pageSubtitle ? <p className="t-memberInfo-pageSubtitle">{pageSubtitle}</p> : null}
        </div>

        <article
          className={`t-memberInfo-card t-memberDetail-header--blue${
            shouldAnimateCard ? " t-memberInfo-card--enter" : ""
          }`}
        >
          <div className="t-memberInfo-cardHeader">
            <div className="t-memberDetail-headerIcon t-memberInfo-cardIcon">
              <i className="t-icon-wallet" aria-hidden="true" />
            </div>

            <div className="t-memberInfo-cardHeaderContent">
              <div className="t-memberInfo-cardTitleRow">
                <h2 className="t-memberInfo-cardTitle">{cardTitle}</h2>
                {paymentTypeLabel ? (
                  <span className="t-memberInfo-typeChip">{paymentTypeLabel}</span>
                ) : null}
              </div>
              {stepBadge ? (
                <div className="t-memberInfo-cardBadges">
                  <span className="t-memberDetail-headerBadge">{stepBadge}</span>
                </div>
              ) : null}
            </div>
          </div>

          {children}
          {renderEminPaySteps(activeStep)}
        </article>
      </div>
    </div>
    <div className="row" style={{ height: 30 }} />
  </div>
);

export const EminPayInfoModal = ({ show, title, subtitle, children, onClose }) => {
  if (!show) return null;

  return (
    <>
      <div
        className="modal fade show t-demandDetailModal"
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
        style={{ display: "block", zIndex: 1055 }}
      >
        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
          <div className="modal-content t-guarantorModal-content border-0">
            <div className="t-guarantorModal-header">
              <div className="t-guarantorModal-header-content">
                <div className="t-guarantorModal-icon">
                  <i className="t-icon-info_outline" aria-hidden="true" />
                </div>
                <div>
                  <h5 className="t-guarantorModal-title">{title}</h5>
                  {subtitle ? <p className="t-guarantorModal-subtitle">{subtitle}</p> : null}
                </div>
              </div>
              <button type="button" className="t-guarantorModal-close" onClick={onClose} aria-label="Kapat">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="t-guarantorModal-body t-eminPayOrder-modalBody">{children}</div>
            <div className="t-guarantorModal-footer">
              <button
                type="button"
                className="t-memberInfo-btn t-memberInfo-btn--primary"
                onClick={onClose}
              >
                <span>Anladım</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show" style={{ zIndex: 1050 }} />
    </>
  );
};

export const EminPayBankRedirectOverlay = () => (
  <div className="t-eminPayRedirect-overlay">
    <div className="t-eminPayRedirect-card">
      <div className="t-eminPayRedirect-icon" aria-hidden="true">
        <i className="t-icon-clock" />
      </div>
      <h3 className="t-eminPayRedirect-title">Lütfen Bekleyin</h3>
      <p className="t-eminPayRedirect-text">
        Ekranı kapatmayın veya ayrılmayın,
        <strong> bankaya yönlendiriliyorsunuz...</strong>
      </p>
    </div>
  </div>
);
